const LOCAL_API_URL = 'http://localhost:4000';
const STAGING_API_URL = 'https://api-staging.navioworks.com';
const PRODUCTION_API_URL = 'https://api.navioworks.com';

const PRODUCTION_HOSTS = new Set(['fit.naviomaritime.com', 'naviofit.pages.dev']);

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

function isLocalHost(host: string): boolean {
  return host === 'localhost' || host === '127.0.0.1';
}

function isLocalApiUrl(url: string): boolean {
  return url.includes('localhost') || url.includes('127.0.0.1');
}

function isProductionHost(host: string): boolean {
  return PRODUCTION_HOSTS.has(host);
}

export function getApiBaseUrl(): string {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const configured = import.meta.env.VITE_API_URL?.trim();
  if (configured) {
    const normalized = trimTrailingSlash(configured);
    if (!isLocalApiUrl(normalized) || isLocalHost(host)) {
      return normalized;
    }
  }

  if (isLocalHost(host)) return LOCAL_API_URL;
  if (isProductionHost(host)) return PRODUCTION_API_URL;
  return STAGING_API_URL;
}
